import $api from 'http/index';
import { getOptions } from 'helpers/getOptions';
import { format, startOfDay, endOfDay } from 'date-fns';
import { downloadFile } from 'helpers/downloadFile';

export const exportWorklogsExcel = async (data, withEquipment) => {
  const searchParams = new URLSearchParams();
  searchParams.append('from', startOfDay(data.period.from).toISOString());
  searchParams.append('to', endOfDay(data.period.to).toISOString());
  
  if (data?.jobNumber?.length) searchParams.append('jobNumber', data.jobNumber.map((v) => v.replace(/,/, '\\,')).join(','));
  if (data?.cl?.length) searchParams.append('cl', data.cl.map((v) => v._id.replace(/,/, '\\,')).join(','));
  if (data?.materialName?.length) searchParams.append('materialName', data.materialName.map((v) => v.replace(/,/, '\\,')).join(','));
  if (data?.materialUnit?.length) searchParams.append('materialUnit', data.materialUnit.map((v) => v.replace(/,/, '\\,')).join(','));
  if (data?.materialColor?.length) searchParams.append('materialColor', data.materialColor.map((v) => v.replace(/,/, '\\,')).join(','));
  if (data?.materialSpecification?.length) searchParams.append('materialSpecification', data.materialSpecification.map((v) => v.replace(/,/, '\\,')).join(','));
  if (data?.lineWidth?.length) searchParams.append('lineWidth', data.lineWidth.join(','));
  if (data?.legendSymbol?.length) searchParams.append('legendSymbol', data.legendSymbol.map((v) => v.replace(/,/, '\\,')).join(','));
  if (data?.letteringText?.length) searchParams.append('letteringText', data.letteringText.map((v) => v.replace(/,/, '\\,')).join(','));
  if (data?.letteringParameters?.length) searchParams.append('letteringParameters', data.letteringParameters.map((v) => v.replace(/,/, '\\,')).join(','));
  if (data?.equipment?.length) searchParams.append('equipment', data.equipment.map((v) => v._id.replace(/,/, '\\,')).join(','));

  if (withEquipment) searchParams.append('withEquipment', 'true');

  const response = await $api.get(
    `${process.env.REACT_APP_BASE_URL}/submissions/materials/excel`,
    {
      params: searchParams,
      ...getOptions('text/xlsx'),
      responseType: 'blob',
    }
  );
  downloadFile(
    response.data,
    `Submissions ${format(data.period.from, 'M-d-yy')}_${format(data.period.to, 'M-d-yy')}.xlsx`
  );
};